import React from 'react';

const PolitiqueConfidentialite = () => {
  return (
    <main className="bg-white min-h-screen pt-28 pb-16 px-6 sm:px-8">
      <div className="max-w-4xl mx-auto text-gray-800">
        <h1 className="text-3xl sm:text-4xl font-semibold text-[#1e3a5f] mb-8">Politique de confidentialite</h1>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Donnees collectees</h2>
          <p>
            Nous pouvons collecter des donnees techniques de navigation (avec consentement), des informations de
            contact et les informations communiquees volontairement via telephone, email ou WhatsApp.
          </p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Base legale</h2>
          <p>
            Le traitement est fonde sur votre consentement, l&apos;interet legitime de gestion du site, et/ou
            l&apos;execution de mesures precontractuelles lorsque vous demandez un rendez-vous.
          </p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Duree de conservation</h2>
          <p>
            Les donnees sont conservees uniquement le temps necessaire aux finalites poursuivies et aux obligations
            legales applicables.
          </p>
        </section>

        <section className="space-y-4 mb-8">
          <h2 className="text-xl font-medium">Vos droits RGPD</h2>
          <p>
            Vous disposez d&apos;un droit d&apos;acces, de rectification, d&apos;effacement, de limitation, d&apos;opposition
            et de portabilite de vos donnees. Vous pouvez egalement retirer votre consentement a tout moment.
          </p>
          <p>Pour exercer vos droits: medesthetique@outlook.com</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-medium">Autorite de controle</h2>
          <p>
            En cas de litige, vous pouvez adresser une reclamation a la CNIL (Commission Nationale de l&apos;Informatique
            et des Libertes): https://www.cnil.fr
          </p>
        </section>
      </div>
    </main>
  );
};

export default PolitiqueConfidentialite;
